import React, { useState } from "react";
import { FaStar } from "react-icons/fa";

const StarRating = ({ DriverRating,totalStars = 5, onRatingChange }) => {
  const [rating, setRating] = useState(0);

  const handleClick = (starValue) => {
    setRating(starValue);
    if (onRatingChange) {
      onRatingChange(starValue);
    }
  };

  return (
    <div className="flex space-x-1">
      {[...Array(totalStars)].map((_, index) => {
        const starValue = index + 1;
        return (
          <FaStar
            key={index}
            className="cursor-pointer transition-colors duration-200"
            color={starValue <= rating ? "#FFD700" : "#fff"}
            size={20}
            onClick={() => handleClick(starValue)}
            initialValue={DriverRating ? DriverRating : 0}
          />
        );
      })}
    </div>
  );
};

export default StarRating;
